export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', isFullScreen: true, keepAlive: false, hidden: true, prem: true },
  },
]
